import moment from "moment";
import axios from "axios";
import { encrypt, decrypt, eaPassword } from "./crypto";

// Converter número para real
export function numberToReal(number) {
  if (number !== null && number !== undefined && number !== "") {
    return JSON.parse(number).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }
  return number;
}

export function maskCnpj(cnpj) {
  const value = normalizeCnpj(cnpj);
  return value.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/, "$1.$2.$3/$4-$5");
}

export function normalizeCnpj(cnpj) {
  return (cnpj || "").toString().replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export function maskIE(ie) {
  return ie.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})/, "$1.$2.$3.$4");
}

export function isNull(object) {
  if (object === null || object === undefined || object === "") {
    return true;
  }
  return false;
}

export function maskNcm(ncm) {
  if (ncm === null || ncm === undefined || ncm === "") {
    return "";
  }
  return ncm.replace(/^(\d{4})(\d{2})(\d{2})/, "$1.$2.$3");
}

export function maskCest(cest) {
  if (cest === null || cest === undefined || cest === "") {
    return "";
  }
  return cest.replace(/^(\d{2})(\d{3})(\d{2})/, "$1.$2.$3");
}

export function formatDate(date) {
  const dateFormat = "DD/MM/YYYY";

  if (date) {
    if (date.includes("/")) {
      return moment(date, dateFormat);
    } else {
      const newDate = moment(date).format(dateFormat);
      return moment(newDate, dateFormat);
    }
  }
  return null;
}

export function dateToEnglish(date) {
  if (date === null || date === undefined || date === "") {
    return null;
  }
  return date ? date.split("/").reverse().join("-") : null;
}

export function dateToBr(date) {
  return date ? date.split("-").reverse().join("/") : null;
}

export function contains(target, pattern, all) {
  var value = 0;
  pattern.forEach((word) => {
    value += target.includes(word);
  });
  if (all) {
    return value === pattern.length;
  }
  return value;
}

// Criptografa um objeto
export function encryptObject(data) {
  return encodeURIComponent(encrypt(encodeURIComponent(JSON.stringify(data)), eaPassword));
}

// Decriptografa um objeto
export function decryptObject(dataStr) {
  return JSON.parse(decodeURIComponent(decrypt(decodeURIComponent(dataStr), eaPassword)));
}

export function getCnpjUrl() {
  const { pathname } = window.location;
  if (pathname.startsWith("/empresa/")) {
    const cnpj = pathname.replace(/^\/empresa\//, "").split("/")[0];
    return normalizeCnpj(decodeURIComponent(cnpj)) || null;
  }
  return null;
}

export function padLeadingZeros(num, size) {
  var s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
}

// Modifica uma string para ter no máximo `tamanho` caracteres adicionando `...` caso tenha mais
export const ellipsisString = (texto, tamanho) => {
  if (texto.length <= tamanho + 3) {
    return texto;
  }

  return `${texto.substring(0, tamanho)}...`;
};

export const getEnderecoByCep = async (cep) => {
  if (!cep) return null;

  cep = cep.replaceAll("-", "").replaceAll("_", "");

  if (cep.length === 8) {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return response.data;
  }
  return null;
};

export const validarCNPJ = (cnpj) => {
  cnpj = normalizeCnpj(cnpj);

  if (cnpj === "") return false;

  if (cnpj.length !== 14) return false;

  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  )
    return false;

  const getCnpjValue = (value) => value.charCodeAt(0) - 48;
  const calcularDigito = (base, pesos) => {
    const soma = base
      .split("")
      .reduce((total, value, index) => total + getCnpjValue(value) * pesos[index], 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  // Valida DVs
  const multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const digito1 = calcularDigito(cnpj.substring(0, 12), multiplicador1);
  const digito2 = calcularDigito(cnpj.substring(0, 12) + digito1, multiplicador2);

  if (`${digito1}${digito2}` !== cnpj.substring(12)) return false;

  return true;
};

export function formatDateString(date) {
  const dateFormat = "DD/MM/YYYY";

  if (date) {
    return moment(date).format(dateFormat);
  }
  return null;
}

export function formatTimeString(time) {
  const timeFormat = "HH:mm";

  if (time) {
    return moment(time).format(timeFormat);
  }
  return null;
}
